import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  &.animation-transform,
  > div {
    will-change: transform;
  }
  ${props => props.customCss};
`;

export const ContainerDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row !important;
  flex-wrap: nowrap;
  height: 100%;
  align-items: center;

  padding: ${props =>
    `0
        calc((100vw - (${props.fullHeight ? 100 : 90} * ${
      props.lastImgAspectRatio
    }${props.fullHeight ? 'vw' : 'vh'})) / 2)
        0
        calc((100vw - (${props.fullHeight ? 100 : 90} * ${
      props.firstImgAspectRatio
    }${props.fullHeight ? 'vw' : 'vh'})) / 2)`};
`;

export const ImageWrapper = styled.div`
  padding: ${props => (props.imagePadding ? '0 8px' : '0')};
  width: ${props =>
    props.fullHeight
      ? `calc(${100 * props.aspectRatio}vh)`
      : `calc(${90 * props.aspectRatio}vh - ${90 * props.aspectRatio}px)`};

  height: ${props => (props.fullHeight ? '100vh' : 'unset')};
`;

export const Image = styled.img`
  max-width: 100%;
  height: ${props => (props.fullHeight ? '100%' : 'calc(90vh - 90px)')};
`;
